import _regeneratorRuntime from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/regenerator";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/helpers/asyncToGenerator";
import _classCallCheck from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/helpers/classCallCheck";
import _createClass from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/helpers/createClass";
import _possibleConstructorReturn from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/helpers/possibleConstructorReturn";
import _getPrototypeOf from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/helpers/getPrototypeOf";
import _inherits from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/helpers/inherits";
import axios from "axios";
import BaseData from "./BaseData";

var ComplianceInspection =
/*#__PURE__*/
function (_BaseData) {
  _inherits(ComplianceInspection, _BaseData);

  function ComplianceInspection() {
    _classCallCheck(this, ComplianceInspection);

    return _possibleConstructorReturn(this, _getPrototypeOf(ComplianceInspection).call(this, "ComplianceInspection"));
  }

  _createClass(ComplianceInspection, [{
    key: "GetInspectionProperties",
    value: function () {
      var _GetInspectionProperties = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee(lookBackNumber) {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                return _context.abrupt("return", axios.get("/api/".concat(this._controller, "/GetInspectionProperties/").concat(lookBackNumber)));

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function GetInspectionProperties(_x) {
        return _GetInspectionProperties.apply(this, arguments);
      }

      return GetInspectionProperties;
    }()
  }, {
    key: "GetInspectionPropertiesByYear",
    value: function () {
      var _GetInspectionPropertiesByYear = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee2(year) {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                return _context2.abrupt("return", axios.get("/api/".concat(this._controller, "/GetInspectionPropertiesByYear/").concat(year)));

              case 1:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function GetInspectionPropertiesByYear(_x2) {
        return _GetInspectionPropertiesByYear.apply(this, arguments);
      }

      return GetInspectionPropertiesByYear;
    }()
  }, {
    key: "GetPropertySpecificInspectionList",
    value: function () {
      var _GetPropertySpecificInspectionList = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee3(projectId) {
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                return _context3.abrupt("return", axios.get("/api/".concat(this._controller, "/GetPropertySpecificInspectionList/").concat(projectId)));

              case 1:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function GetPropertySpecificInspectionList(_x3) {
        return _GetPropertySpecificInspectionList.apply(this, arguments);
      }

      return GetPropertySpecificInspectionList;
    }()
  }, {
    key: "GetLastRelatedInspection",
    value: function () {
      var _GetLastRelatedInspection = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee4(projectId, inspectionId) {
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                return _context4.abrupt("return", axios.get("/api/".concat(this._controller, "/GetLastRelatedInspection/").concat(projectId, "/").concat(inspectionId)));

              case 1:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function GetLastRelatedInspection(_x4, _x5) {
        return _GetLastRelatedInspection.apply(this, arguments);
      }

      return GetLastRelatedInspection;
    }()
  }, {
    key: "EmailInspector",
    value: function () {
      var _EmailInspector = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee5(complianceInspectionId) {
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                return _context5.abrupt("return", axios.post("/api/".concat(this._controller, "/EmailInspector/").concat(complianceInspectionId)));

              case 1:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function EmailInspector(_x6) {
        return _EmailInspector.apply(this, arguments);
      }

      return EmailInspector;
    }()
  }]);

  return ComplianceInspection;
}(BaseData);

export default new ComplianceInspection();